/* DEBIT CARD */
export const setLoading = (payload) => ({
  type: "LOADING_DEFAULT",
  payload,
});

export const openModalDebitComp = (openModalDebit) => ({
  type: "OPEN_MODAL_DEBIT",
  openModalDebitValue: openModalDebit,
});

export const filterDebits = (filterDebits) => ({
  type: "FILTER_DEBITS",
  filterDebitsValue: filterDebits,
});

export const debitsFilterPreferences = (filters) => ({
  type: "DEBITS_FILTER_PREFERENCES",
  debitsFilterPreferences: filters,
});

export const hasBeenReadModalUserMessageComp = (
  hasBeenReadModalUserMessage
) => ({
  type: "OPEN_MODAL_USER_MESSAGE",
  hasBeenReadModalUserMessageValue: hasBeenReadModalUserMessage,
});

export const checkAllVincendoComp = (checkAllVincendo) => ({
  type: "CHECK_ALL_VINCENDO",
  checkAllVincendoValue: checkAllVincendo,
});

export const valueAmountComp = (valueAmount) => ({
  type: "VALUE_AMOUNT",
  valueAmountValue: valueAmount,
});

export const debitsComp = (debits) => ({
  type: "DEBITS",
  debitsValue: debits,
});

export const debitsSelectedComp = (debitsSelected) => ({
  type: "DEBITS_SELECTED",
  debitsSelectedValue: debitsSelected,
});

export const debitsSelectedIDsComp = (debitsSelectedIDs) => ({
  type: "DEBITS_SELECTED_IDS",
  debitsSelectedIDsValue: debitsSelectedIDs,
});

export const openSnackComp = (openSnack) => ({
  type: "OPEN_SNACK",
  openSnackValue: openSnack,
});

export const openConfirmDialogComp = (openConfirmDialog) => ({
  type: "OPEN_CONFIRM_DIALOG",
  openConfirmDialogValue: openConfirmDialog,
});

export const registerDebitAutomaticComp = (registerDebitAutomatic) => ({
  type: "REGISTER_AUTOMATIC_DEBIT",
  registerDebitAutomaticValue: registerDebitAutomatic,
});

export const noMixedBankDataComp = (noMixedBankData) => ({
  type: "NO_MIXED_BANK_DATA",
  noMixedBankDataValue: noMixedBankData,
});

export const amountDueComp = (amountDue) => ({
  type: "AMOUNT_DUE",
  amountDueValue: amountDue,
});

export const modalFilterContribuitesComp = (filter) => ({
  type: "MODAL_SELECTED",
  modalFilterContribuitesValue: filter,
});

export const damComp = (dam) => ({
  type: "DAM",
  damValue: dam,
});

export const damTotalRegistrosComp = (totalRegistros) => ({
  type: "DAM_TOTAL_REGISTROS",
  damTotalRegistrosValue: totalRegistros,
});

export const damTotalPaginasComp = (totalPaginas) => ({
  type: "DAM_TOTAL_PAGINAS",
  damTotalPaginasValue: totalPaginas,
});

export const damNumeroPaginaComp = (numeroPagina) => ({
  type: "DAM_NUMERO_PAGINA",
  damNumeroPaginaValue: numeroPagina,
});

export const damTamanhoPaginaComp = (tamanhoPagina) => ({
  type: "DAM_TAMANHO_PAGINA",
  damTamanhoPaginaValue: tamanhoPagina,
});

export const damSelectedComp = (damSelected) => ({
  type: "DAM_SELECTED",
  damSelectedValue: damSelected,
});

export const damSelectedIDsComp = (damSelectedIDs) => ({
  type: "DAM_SELECTED_IDS",
  damSelectedIDsValue: damSelectedIDs,
});

export const setCurrentPageAfterFilter = (currentPage) => ({
  type: "SET_CURRENT_PAGE_AFTER_FILTER",
  currentPageAfterFilterValue: currentPage,
});

export const setClearFilterDebit = (valueFilter) => ({
  type: "SET_CLEAR_FILTER_DEBIT",
  clearFilterDebit: valueFilter,
});

export const setGridRowsPerPage = (row) => ({
  type: "SET_ROWS_PER_PAGE",
  rowsPerPage: row,
});

export const setOpenBankInfos = (openBankInfos) => ({
  type: "OPEN_BANK_INFOS",
  openBankInfos: openBankInfos,
});

export const setPaymentDateValue = (paymentDateValue) => ({
  type: "PAYMENT_DATE_VALUE",
  paymentDateValue: paymentDateValue,
});

export const setAcquirersActives = (acquirersActives) => ({
  type: "ACQUIRERS_ACTIVES",
  acquirersActives: acquirersActives,
});

export const setPaymentCreditCardObject = (paymentCreditCardObject) => ({
  type: "PAYMENT_CREDIT_CARD_OBJECT",
  paymentCreditCardObject: paymentCreditCardObject,
});

export const setAcquirerSelected = (acquirerSelected) => ({
  type: "ACQUIRER_SELECTED",
  acquirerSelected: acquirerSelected,
});

export const setExpirationDay = (data) => ({
  type: "SET_EXPIRATION_DAY",
  dateExpiration: data,
});

export const setBankSelectedOnlinePayment = (bankSelectedOnlinePayment) => ({
  type: "BANK_SELECTED_ONLINE_PAYMENT",
  bankSelectedOnlinePayment: bankSelectedOnlinePayment,
});

export const listAdquirentes = (filterListAdquirentes) => ({
  type: "LIST_ADQUIRENTES",
  filterListAdquirentes: filterListAdquirentes,
});

export const setSelectedUser = (selectedUser) => ({
  type: "SET_SELECTED_USER_SEARCH",
  payload: selectedUser,
});

export const validaDebitsMessage = (message) => {
  return {
    type: "VALID_DEBITS_MESSAGE",
    payload: message,
  };
};
